import { Box, Center, Flex, Image, Progress, Stack } from "@chakra-ui/react";
import React from "react";
import catImg from "../assets/images/hero-img.svg";
import colon from "../assets/images/colon.svg";
import usdt from "../assets/images/icon_usdt.svg";
import eth from "../assets/images/logo_eth.svg";
import card from "../assets/images/icon_card.svg";
import CustomText from "./CustomText";
import { AmountInput, CryptoBox, KeyValue, TimeBox } from "./Boxes";
import CustomButton from "./CustomButton";

const Hero = () => {
  return (
    <section id="home">
      <Flex
        // gap={"20px"}
        pt={"96px"}
        pb={"220px"}
        align={"center"}
        flexDir={{ base: "column", lg: "row" }}
        maxW={"1250px"}
        mx={"auto"}
      >
        <Box
          w={{ base: "full", lg: "50%" }}
          width={{ lg: "733px" }}
          h={{ lg: "587px" }}
          zIndex={1}
          ml={{ lg: "-100px" }}
        >
          <Image src={catImg} alt="Cat" />
        </Box>
        <Stack
          w={{ base: "full", lg: "50%" }}
          borderRadius={"20px"}
          border={"7px solid #000"}
          bg={"#FFFAFF"}
          p={{ base: "8px 4px", md: "16px 8px", lg: "20px 10px" }}
          gap={"20px"}
          ml={{ base: "-10px", lg: "-50px" }}
        >
          <Center>
            <CustomText
              text="Buy Ferry Silence coins"
              size="24px"
              color="#191919"
              height="27.31px"
            />
          </Center>
          <Flex
            align={"center"}
            gap={"10px"}
            justify={"stretch"}
            flexDirection={{ base: "column", md: "row" }}
          >
            <TimeBox text1="9" text2="Days" />
            <Image src={colon} alt="colon" />
            <TimeBox text1="21" text2="hours" />
            <Image src={colon} alt="colon" />
            <TimeBox text1="19" text2="minutes" />
            <Image src={colon} alt="colon" />
            <TimeBox text1="24" text2="seconds" />
          </Flex>
          <Box>
            <Progress
              value={40}
              borderRadius={"50px"}
              colorScheme="orange"
              bg={"rgba(0,0,0,0.5)"}
              height={"23px"}
            />
            <Box mt={"-23px"} position={"relative"} textAlign={"center"}>
              <CustomText
                text="Until price increases"
                size={{ base: "16px", md: "20px" }}
                height="22.76px"
                color="#FFFAFF"
              />
            </Box>
          </Box>
          <KeyValue text1="USDT Raised" text2="$543,458.68 / $1621,361.00" />
          <KeyValue text1="Your Purchased $Furry" text2="0" />
          <KeyValue text1="Your stakeable $Furry" text2="0" />
          <Center>
            <CustomText
              text="1 $Furry = 0.0088"
              size={{ base: "18px", md: "24px" }}
              height="27.31px"
              color="#191919"
            />
          </Center>
          <Flex w={"100%"} gap={"10px"} align={"center"}>
            <CryptoBox img={eth} name={"ETH"} />
            <CryptoBox img={usdt} name={"USDT"} />
            <CryptoBox img={card} name={"Card"} />
          </Flex>
          <Flex align={"center"} gap={"10px"}>
            <Stack w={"50%"}>
              <Flex w={"100%"} justify={"space-between"} px={"10%"}>
                <CustomText text="USDT you pay" />
                <CustomText text="MAX" />
              </Flex>
              <AmountInput value={0} img={eth} />
            </Stack>
            <Stack w={"50%"}>
              <Flex px={"10%"}>
                <CustomText text="$furry you receive" />
              </Flex>
              <AmountInput value={0} img={usdt} />
            </Stack>
          </Flex>
          <Flex align={"center"} gap={"10px"}>
            <CustomButton text="Connect Wallet" />
            <CustomButton
              text="Buy With Base"
              border="3px solid #E17F09"
              bg="#FFFAFF"
              color="#191919"
            />
          </Flex>
        </Stack>
      </Flex>
    </section>
  );
};

export default Hero;
